import ArrowRight from "app/common/icons/ArrowRight";
import Calendar from "app/common/icons/Calendar";
import Cancel from "app/common/icons/Cancel";
import CancelCircle from "app/common/icons/CancelCircle";
import Chat from "app/common/icons/Chat";
import CircleCheck from "app/common/icons/CircleCheck";
import CloudDownload from "app/common/icons/CloudDownload";
import DangerBlocks from "app/common/icons/DangerBlocks";
import Delete from "app/common/icons/Delete";
import Edit from "app/common/icons/Edit";
import Envelope from "app/common/icons/Envelope";
import FileError from "app/common/icons/FileError";
import FileZip from "app/common/icons/FileZip";
import FolderUpload from "app/common/icons/FolderUpload";
import HourGlass from "app/common/icons/HourGlass";
import Info from "app/common/icons/Info";
import Kaddim from "app/common/icons/Kaddim";
import Plus from "app/common/icons/Plus";
import Search from "app/common/icons/Search";
import Settings from "app/common/icons/Settings";
import ShortText from "app/common/icons/ShortText";
import SmartDisplay from "app/common/icons/SmartDisplay";
import SMS from "app/common/icons/SMS";
import Upload from "app/common/icons/Upload";
import WarningBlocks from "app/common/icons/WarningBlocks";

export const CloudDownloadIcon = CloudDownload;
export const DeleteIcon = Delete;
export const WarningBlocksIcon = WarningBlocks;
export const DangerBlocksIcon = DangerBlocks;
export const PlusIcon = Plus;
export const EditIcon = Edit;
export const CancelIcon = Cancel;
export const CancelCircleIcon = CancelCircle;
export const HourGlassIcon = HourGlass;
export const CalendarIcon = Calendar;
export const ChatIcon = Chat;
export const EnvelopeIcon = Envelope;
export const FileErrorIcon = FileError;
export const ArrowRightIcon = ArrowRight;
export const UploadIcon = Upload;
export const CircleCheckIcon = CircleCheck;
export const FileZipIcon = FileZip;
export const SearchIcon = Search;
export const SettingsIcon = Settings;
export const InfoIcon = Info;
export const SMSIcon = SMS;
export const ShortTextIcon = ShortText;
export const KaddimIcon = Kaddim;
export const SmartDisplayIcon = SmartDisplay;
export const FolderUploadIcon = FolderUpload;
